import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { styledMedia } from '@pkg/primitives';

import { pageFrameBase } from '../../styles';

export const HeaderWrapper = styled.header`
    ${pageFrameBase};
    justify-content: space-between;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        top: 0;
    }
`;

// TODO: Add focus-ring.
export const BrandLink = styled(Link)`
    // TODO: Remove this &&& once we fix v2-global-reset.
    &&& {
        ${styledMedia.iconWrapper};
        display: block;
        height: var(--yat_header-brand-height);
        transition: opacity 200ms ease-in-out;

        &:hover {
            opacity: 0.8;
        }

        &:active {
            opacity: 1;
        }

        svg {
            // NOTE: This fixes a bug in Safari causing misalignment
            width: auto;
        }
    }
`;
